import { render, staticRenderFns } from "./FormBuilderUserData.vue?vue&type=template&id=afdc6b78&scoped=true"
import script from "./FormBuilderUserData.vue?vue&type=script&lang=js"
export * from "./FormBuilderUserData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdc6b78",
  null
  
)

export default component.exports